import {Fragment} from 'react'
import {useNavigate} from 'react-router-dom'

import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'

import Field from './Field'
import FormWrapper from './FormWrapper'
import Loader from './Loader'

import {fullName, isEmpty} from '../../lib/tools'

const HIDDEN_FIELDS = ['id', 'invitedById']

import './details.scss'

const Details = props => {
  const {errors = {}} = props.formMethods?.formState || {}
  const navigate = useNavigate()
  const Container = props.edit ? FormWrapper : Fragment
  const EditActions = props.editActions
  const HeaderActions = props.headerActions

  const goBack = () => {
    navigate(-1)
  }

  const editDetails = () => {
    navigate('edit')
  }

  return (
    <Loader loading={isEmpty(props.data)}>
      <Box className='record-details' sx={{width: '80%'}}>
        <Stack sx={{flexDirection: 'row', justifyContent: 'space-between'}}>
          <Typography className='heading' variant='h4'>{fullName(props.data)}</Typography>
          {
            props.headerActions && (
              <Stack sx={{flexDirection: 'row'}}>
                <HeaderActions {...props} goBack={goBack} />
              </Stack>
            )
          }
        </Stack>
        <Container {...(props.edit && {methods: props.formMethods, handleSubmit: props.handleSubmit})}>
          <Grid className='gutter-large' container rowSpacing={1} columnSpacing={{xs: 1, sm: 2, md: 3}}>
              {
                Object.keys(props.data).map(
                  (label, index) => {
                    const value = props.data[label]

                    if (value && !HIDDEN_FIELDS.includes(label)) {
                      return (
                        <Grid key={index} size={6}>
                          <Field edit={props.edit} errors={errors} label={label} value={value} />
                        </Grid>
                      )
                    } else {
                      return null
                    }
                  }
                )
              }
            </Grid>
        </Container>
        <Divider />
        {
          props.editActions && (
            <Stack className='actions' sx={{flexDirection: 'row', justifyContent: 'space-between'}}>
              <EditActions {...props} editDetails={editDetails} goBack={goBack} />
            </Stack>
          )
        }
      </Box>
    </Loader>
  )
}

export default Details
